/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Icon from '@mui/material/Icon';
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Divider from "@mui/material/Divider";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import SoftAvatar from "components/SoftAvatar";
import { min } from 'draft-js/lib/DefaultDraftBlockRenderMap';
import zIndex from '@mui/material/styles/zIndex';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    outline: 'none',
    borderRadius: '1rem',
    maxHeight: '90vh',
    maxWidth: '150vw',
    overflowY: 'auto',
    minWidth: 'calc(100px + 50%)',
    backdropFilter: 'brightness(2.0) blur(15px)',
    background: "#ffffffb5",
};

const useStyles = makeStyles({
    stepper: {
        fontSize: '10px !important',
    },
    stepLabel: {
        fontSize: '10px !important',
    },
});

const CustomStepper = styled(Stepper)(({ theme }) => ({
    '& .MuiStepLabel-label': {
        fontSize: '14px !important',
    },
}));

function createItems(title, text) {
    let items = [];

    if (title) {
        items.push(
            <SoftBox pt={3} px={3} key={title}>
                <SoftTypography display="inline" variant="body2" verticalAlign="middle" fontSize="14px">
                    <Icon sx={{ fontWeight: "bold", color: "error" }}>
                        label_important
                    </Icon>
                    <strong>{title} </strong>  <br></br>
                    <SoftTypography variant="caption" color="secondary" fontWeight="medium" fontSize="12px"> {text}</SoftTypography>
                </SoftTypography>
            </SoftBox>
        );
    }

    return items;
}

function getSteps() {
    return ["1. Savunma Talep Edildi", "2. Savunma Alındı", "3. Tercüme Yapıldı", "4. Karar Alındı", "5. Karar Yazıldı", "6. Karar Tebliğ Edildi"];
}

const Target = ({ id, image, name, email, tel, variant }) => {
    return (
        <a href={`/profile/${id}`} >
            <SoftBadge variant={variant} badgeContent={
                <SoftBox display="flex" alignItems="center" px={1} py={0.5}  >
                    <SoftBox mr={2}>
                        <SoftAvatar src={image} size="sm" variant="rounded" />
                    </SoftBox>
                    <SoftBox display="flex" flexDirection="column" alignItems="flex-start">
                        <SoftTypography variant="button" fontWeight="medium">
                            {name}
                        </SoftTypography>
                        <SoftTypography variant="caption" color="dark">
                            {email}
                        </SoftTypography>
                        <SoftTypography variant="caption" color="secondary">
                            {tel}
                        </SoftTypography>
                    </SoftBox>
                </SoftBox>
            } color="light" size="xl" container />
        </a >
    );
};

const Evrak = ({ id, image, name, aciklama, tel, variant, fileType }) => {
    const renderPreview = () => {
        switch (fileType) {
            case 'video':
                return <video controls src={id} style={{ width: '300px', boxShadow: "0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 22%)", borderRadius: "0.5rem" }} />;
            case 'audio':
                return <audio controls src={id} style={{ width: '300px', boxShadow: "0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 22%)", borderRadius: "0.5rem", background: "#f2f3f4" }} />;
            case 'image':
                return <img src={image} alt={name} style={{ width: '300px', boxShadow: "0rem 1.25rem 1.6875rem 0rem rgb(0 0 0 / 22%)", borderRadius: "0.5rem" }} />;
            default:
                return (
                    <a href={`${id}`} target="_blank" rel="noopener noreferrer">
                        {name}
                    </a>
                );
        }
    };

    return (
        <>
            <Divider />
            <SoftBadge variant={variant} badgeContent={
                <SoftBox display="flex" flexDirection="column" alignItems="flex-start" px={1} py={0.5}  >
                    <SoftBox mr={2}>
                        {renderPreview()}
                    </SoftBox>
                    <a href={id} target="_blank" rel="noopener noreferrer">
                        <SoftBox display="flex" flexDirection="column" alignItems="flex-start" pt={6}>
                            <SoftTypography variant="button" fontWeight="medium">
                                {aciklama}
                            </SoftTypography>
                            <SoftTypography variant="caption" color="dark" >
                                {name}
                            </SoftTypography>
                            {/* <SoftTypography variant="caption" color="secondary">
                        {name}
                    </SoftTypography> */}
                        </SoftBox>
                    </a>
                </SoftBox>
            } color="light" size="xl" container />
        </>
    );
};

export default function BasicModal({ open, handleClose, content, contentCode }) {
    const [activeStep, setActiveStep] = useState(0);
    const steps = getSteps();
    const classes = useStyles();

    const stepsName = [
        'savunmanin_istenmesi',
        'savunmanin_alinmasi',
        'tercumenin_yapilmasi',
        'karar_alinmasi',
        'karar_yazilmasi',
        'kararın_teblig_edilmesi'
    ];

    const getStepIndex = (content) => {
        for (let i = 0; i < stepsName.length; i++) {
            if (content?.[stepsName[stepsName.length - i - 1]] || content?.[stepsName[stepsName.length - i]] === "true") {
                return stepsName.length - i - 1;
            }
        }
        return -1;
    };

    useEffect(() => {
        const activeStepId = getStepIndex(content);
        setActiveStep(activeStepId);
    }, [content]);

    console.log(contentCode)
    console.log("contentCode tipi:", typeof contentCode);
    console.log("React elemanı mı?:", React.isValidElement(contentCode));
    console.log("contentCode değeri:", contentCode);

    if (!contentCode || contentCode === null || contentCode === undefined || contentCode === false || React.Children.count(contentCode) === 0) {
        console.log("contentCode BOŞ!");
      }
      
    

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <SoftBox sx={style}>
                
                {contentCode && contentCode?.props?.logsData?.logs?.length > 0 ? contentCode : (


                    <div style={{ justifySelf: "center", width: "75%" }}>
                    
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "30px", }}>
                      <Icon sx={{ cursor: "pointer", fontWeight: "bold", background: "linear-gradient(310deg, #bec4d9, #f3f4f5)", "-webkit-background-clip": "text", "-webkit-text-fill-color": "transparent" }} fontSize="large" color="#aaa">warning</Icon>
                      <SoftTypography variant="button" color="secondary" fontWeight="regular" style={{ height: "50px" }}>
                        Sayfa sonucu bulunamadı
                      </SoftTypography>
                    </div>
                  </div>)}
            </SoftBox>
        </Modal>
    );
}
